import React from 'react'
import {Glyphicon} from 'react-bootstrap'

const icons = {
  error: 'warning-sign',
  warning: 'warning-sign',
  info: 'info-sign',
  success: 'ok-sign',
};

const ToastMessage = ({iconStyle, message}) => {
  return (
    <div>
      <Glyphicon glyph={icons[iconStyle]}/><span className="error-message">{message}</span>
    </div>
  )
};

export default ToastMessage;


// WEBPACK FOOTER //
// ./src/components/common/toast-message.jsx